import PropTypes from 'prop-types'
import { classNames } from '../../helpers'

/**
 * TailwindUI Application UI / Elements / Badge
 * Supporting Basic badges, large badges
 * https://tailwindui.com/components/application-ui/elements/badges
 *
 * `wrap` lässt lange Werte umbrechen statt über den Container hinauszulaufen
 * (z.B. Dropdown-Antworten auf der Talent-Detailseite). rounded-xl sieht bei
 * einer Zeile aus wie rounded-full, bleibt bei mehreren Zeilen aber eine Pille.
 */
const Badge = ({ type, text, color, wrap, className }) => {
  function getColorClassname() {
    switch (color) {
      case 'gray':
        return 'bg-gray-100 text-gray-800'
      case 'red':
        return 'bg-red-100 text-red-800'
      case 'yellow':
        return 'bg-yellow-100 text-yellow-800'
      case 'green':
        return 'bg-green-100 text-green-800 border border-[#BCE7CB]'
      case 'blue':
        return 'bg-blue-100 text-blue-800'
      case 'indigo':
        return 'bg-indigo-100 text-indigo-800'
      case 'purple':
        return 'bg-purple-100 text-purple-800'
      case 'pink':
        return 'bg-pink-100 text-pink-800'

      default:
        break
    }
  }

  return (
    <span
      className={classNames(
        'inline-flex items-center py-0.5 font-medium',
        wrap
          ? 'max-w-full whitespace-normal break-words rounded-xl text-left'
          : 'whitespace-nowrap rounded-full',
        getColorClassname(),
        type === 'basic' ? 'px-2.5 text-xs' : 'px-3 text-sm',
        className
      )}
    >
      {text}
    </span>
  )
}

Badge.propTypes = {
  type: PropTypes.oneOf(['basic', 'large']),
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    'gray',
    'red',
    'yellow',
    'green',
    'blue',
    'indigo',
    'purple',
    'pink'
  ]),
  wrap: PropTypes.bool,
  className: PropTypes.string
}

Badge.defaultProps = {
  type: 'basic',
  text: 'missing proptype text',
  color: 'gray',
  wrap: false
}

export default Badge
